import { useQuery } from '@tanstack/react-query';
import { USE_MOCK, surveyApi, retryOnTransientError } from '@/api/client';
import { reportApiError } from '@/utils/errorReporter';
import type { AnsweredInstance } from '@/api/types';

/** Encuestas mostradas en el historial de retroalimentación entregada. */
const DEFAULT_LIMIT = 5;

const MOCK_ANSWERED: AnsweredInstance[] = [
  {
    instanceId: 'mock-1',
    surveyName: 'Fundamentales Q1',
    meetingSubject: 'Revisión trimestral',
    participantCount: 4,
    respondedAt: '2026-01-28T10:00:00Z',
  },
  {
    instanceId: 'mock-2',
    surveyName: 'Colaboración',
    meetingSubject: 'Planeación de sprint',
    participantCount: 2,
    respondedAt: '2026-01-25T10:00:00Z',
  },
];

/**
 * Encuestas que la persona ya respondió. Reemplaza la lista fija que el dashboard
 * pintaba en duro, idéntica para todos los usuarios y solo en español.
 */
export function useMyAnswered(userId?: string, limit = DEFAULT_LIMIT) {
  return useQuery<AnsweredInstance[]>({
    queryKey: ['myAnswered', userId, limit],
    retry: retryOnTransientError,
    queryFn: async () => {
      if (USE_MOCK) return MOCK_ANSWERED;
      try {
        return (await surveyApi.getMyAnswered(userId, limit)) ?? [];
      } catch (apiError) {
        reportApiError('surveys.myAnswered', apiError);
        throw apiError;
      }
    },
  });
}
